export default (data: string | Array<any> | object | boolean | number) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(data)
  }
}
